import { Text, Flex, Spacer, HStack, Stack, Link } from '@chakra-ui/react';
import { FaInstagram, FaDiscord, FaTwitter, FaMedium } from 'react-icons/fa';
import { Link as RouterLink } from "react-router-dom";
import { useMediaQuery } from '@chakra-ui/media-query';
import { SimpleGrid } from '@chakra-ui/layout';

function Footer() {

    const [caption] = useMediaQuery('(min-width: 1000px)')
    const iconSize = '28px';

    return(
        <Flex backgroundColor='#506369' padding='5' className='text' textColor='white' fontSize='18' fontFamily='monospace' minHeight='10vh'>
            <HStack width='full' mx='10' >
                <HStack spacing='8'>
                    <Text>
                        {caption ? 'Made with ❤️ by Team eclair' : '❤️' }
                    </Text>
                    <SimpleGrid spacing='8' outline='none'  columns={{base:2, md:4}}>
                            <Link href="https://www.instagram.com/eclair.app/" isExternal> <FaInstagram size={iconSize}/></Link>
                            <Link href="https://discord.io/eclairapp" isExternal> <FaDiscord size={iconSize}/></Link>
                            <Link href="https://twitter.com/eclairapp" isExternal> <FaTwitter size={iconSize}/></Link>
                            <Link href="https://rohanphww.medium.com/" isExternal> <FaMedium size={iconSize} /> </Link>
                    </SimpleGrid>
                </HStack>
                <Spacer />
                <SimpleGrid spacing='4' columns={{base:1, md:3}} textAlign='center'>
                    <RouterLink to='/nfts'> explore</RouterLink>
                    <RouterLink to='/mint'>mint</RouterLink>
                    <RouterLink to='/faq'>FAQs</RouterLink>
                </SimpleGrid>
            </HStack>
        </Flex>
    
    )
}

export default Footer;